// Builders
import { buildEcommerceItems } from "./builders/buildEcommerceItems"

// Classes
import { ProductItem } from "./classes/ProductItem"
import { ProductTrackingData } from "./classes/ProductTrackingData"

// Types
import { PrestationData } from "@/types/index"

function trackViewItem(
	products: PrestationData[],
	event: "view_item",
	packCode: string,
	averageRatingPerLihe: number,
	reviewNumberPerLihe: string,
	cheapestPrestationIndex: number
): void {
	if (!event) throw new Error("eventName is mandatory in trackViewItem")
	const ecommerceObject: { ecommerce: { items: ProductItem[] } } | undefined =
		buildEcommerceItems(
			products,
			packCode,
			averageRatingPerLihe,
			reviewNumberPerLihe,
			cheapestPrestationIndex
		)

	if (!ecommerceObject) {
		throw new Error("no ecommerceObject built")
	}

	const trackingObject = new ProductTrackingData(ecommerceObject.ecommerce)

	window.dataLayer.push({
		event: trackingObject.event,
		ecommerce: ecommerceObject.ecommerce,
	})
}

export default trackViewItem
